import { SHORT_DATE_TIME_FORMAT } from 'constants/dates';
import { IPodData, IPodDataSimlified } from 'services/pod/types';
import { getFormattedDate } from 'utils/dates';

export const convertSimplifiedToPodData = (data: IPodDataSimlified): IPodData => ({
  TicketId: 0,
  TicketNumber: '',
  ContactId: data.id,
  CompanyId: data.companyId,
  CompanyName: data.companyName,
  ContactName: data.name,
  ContactInitials: '',
  ContactPhone: data.phone ?? '',
  ContactEmail: data.email ?? '',
  isVerified: data.isVerified,
  optedStatus: data.optedStatus,
  msTenantHasOnboarded: data.msTenantHasOnboarded,
  clientPortalChats: [],
  communicationItems: data.communicationItems.map(item => ({
    Name: item.name,
    Type: item.type,
    Value: item.value,
    IsVerified: item.isVerified,
  })),
  history: data.history.map(item => ({
    Date: getFormattedDate(item.date, SHORT_DATE_TIME_FORMAT),
    Item: item.item ?? '',
    Type: item.type,
    Inspector: item.inspector,
    Notes: item.notes,
    IsRevoked: item.isRevoked,
  })),
});
